import { render, staticRenderFns } from "./DMI_SettingsWindow.vue?vue&type=template&id=6b7aca92&scoped=true"
import script from "./DMI_SettingsWindow.vue?vue&type=script&lang=js"
export * from "./DMI_SettingsWindow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b7aca92",
  null
  
)

export default component.exports